/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { FormArray } from '@angular/forms';
import {
  BuilderFormSchemaFactory,
  BuilderFormStateSchema,
  BuilderUserContext, FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { AppFormGroup, updateChildrenSchema, whenUsRegion } from '@gh/common-shared';
import { FormMode, getControl } from '@gh/core-ui';
import { ImportPriceApplyItem } from '../../resources/estimating-import-price-tab.model';
import { SalesTaxRate } from '../../resources/estimating-sales-tax-rates-tab.model';

@Injectable()
export class EstimatingimportPriceTabFormState extends FormState<{ items: ImportPriceApplyItem[] }> {

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  updateSchemaItemGroupRequired(group: AppFormGroup, checked: boolean): void {
    updateChildrenSchema(group, {
      uomId: { enabled: checked },
      isSalesTax: { enabled: checked },
      name: { enabled: checked },
      memo: { enabled: checked },
    });
  }

  updateSchemaItemGroupsRequired(checked: boolean): void {
    const itemsGroup = <FormArray>getControl(this.group, 'items');
    itemsGroup.controls.forEach((itemGroup: AppFormGroup) => {
      updateChildrenSchema(itemGroup, {
        uomId: { enabled: checked },
        isSalesTax: { enabled: checked },
        name: { enabled: checked },
        memo: { enabled: checked },
      });
    });
  }

  protected buildSchema(newItems: { items: ImportPriceApplyItem[] },
                        { root, array, group }: FormStateSchema): FormRootSchema {
    return root({
      mode: FormMode.EditMode,
      optimisticLock: true,
      children: {
        items: array({
          children: newItems.items.map((item) => group({
            key: item.uploadItemId,
            children: {
              uploadItemId: void 0,
              status: void 0,
              code: { enabled: false },
              cost: { enabled: false },
              uomId: { required: true, enabled: false },
              isSalesTax: { visible: whenUsRegion(), enabled: false },
              name: { required: true, enabled: false },
              memo: { enabled: false },
            },
          })),
        }),
      },
    });
  }
}
